import { ariaAttr } from '@mote/helpers'
import React from 'react'
import styled, { css } from 'styled-components'

export const Input = React.forwardRef(
  (
    {
      name,
      disabled = false,
      placeholder,
      label,
      onClick,
      onChange,
      htmlType = 'text',
      value,
      htmlAutocomplete = 'off',
      readOnly = false,
      invalid = false,
      required = false,
      className,
      ...rest
    },
    ref
  ) => {
    return (
      <Root disabled={disabled} onClick={e => onClick?.(e)}>
        {label && <LabelWrapper>{label}</LabelWrapper>}
        <StyledInput
          ref={ref}
          className={className}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          type={htmlType}
          autoCorrect='off'
          autoCapitalize='off'
          spellCheck='false'
          autoComplete={htmlAutocomplete}
          readOnly={readOnly}
          invalid={invalid}
          aria-invalid={ariaAttr(invalid)}
          aria-required={ariaAttr(required)}
          aria-readonly={ariaAttr(readOnly)}
          aria-placeholder={ariaAttr(placeholder)}
          disabled={disabled}
          {...rest}
        />
      </Root>
    )
  }
)

const Root = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`

const StyledInput = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  padding: 0 16px;
  font-weight: normal;
  font-size: 15px;
  line-height: 100%;
  color: #25252d;
  appearance: none;
  border: 1px solid #d1d1e0;
  background: #ffffff;
  transition: all 150ms ease-out;

  &::placeholder {
    color: #b2b2cc;
    font-weight: normal;
    text-transform: none;
  }

  &:hover {
    border-color: #b2b2cc;
  }

  &:active,
  &:focus {
    outline: none;
    border: 1px solid #ac0ae8;
    box-shadow: 0 0 0 1px #ac0ae8;
  }

  ${({ invalid, disabled }) =>
    !disabled &&
    invalid &&
    css`
      border-color: #f44336;

      &:hover {
        border-color: #f44336;
      }

      &:active,
      &:focus {
        outline: none;
        border-color: #f44336;
        box-shadow: 0 0 0 1px #f44336;
      }
    `};
`

const LabelWrapper = styled.label`
  text-transform: capitalize;
  font-weight: 500;
  font-size: 15px;
  line-height: 100%;
  color: #232323;
  margin-bottom: 8px;
`
